var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-input"},[_c('input',{staticClass:"button",attrs:{"type":"button","value":_vm.text,"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.handler(_vm.parameters)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }